<template>
  <div>
    <ModalCover @closeModal="$emit('closeTriggered')">
      <!-- MODAL BODY -->
      <div slot="modal-cover-body">
        <div class="welcome-modal">
          <img
            :src="localImg('SummerWelcome.svg')"
            alt=""
            class="w-100 h-auto"
          />

          <!-- TITLE  -->
          <div class="title-text text-center brand_navy font-weight-700">
            Welcome to Summer School
          </div>

          <!-- DESCRIPTION  -->
          <div class="description text-center color_ash">
            Thank you for joining Gradely Online Summer School. We look forward
            to a fun learnig experience with you.
          </div>

          <!-- GET STARTED  -->
          <div class="d-flex justify-content-center">
            <button class="btn btn-accent font-weight-600" @click="getStarted">
              Get Started
            </button>
          </div>
        </div>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ModalCover from "@/components/globalComps/ModalCover";

export default {
  name: "SummerSchoolWelcomeModal",

  components: {
    ModalCover,
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },

  methods: {
    ...mapActions(["updateNewFeatureLog"]),

    getStarted() {
      // UPDATE SUMMER CONFIG
      this.updateNewFeatureLog({
        name: "summer_config",
        type: this.account_type,
      });

      if (this.account_type === "parent")
        this.$router.push({
          name: "SummerSchoolConnectChildOnboarding",
        });
      else
        this.$router.push({
          name: "SummerSchoolConnectChildOnboardingStudent",
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome-modal {
  background: #fceacf;
  padding: 30px;

  .title-text {
    font-size: 22px;
    line-height: 25px;
    margin: 30px auto 15px;
  }

  .description {
    font-size: 15px;
    line-height: 165%;
    margin-bottom: 20px;
  }

  .btn {
    font-size: 12.25px;
  }
}
</style>
